import React, { Fragment } from 'react';
import {
	Button,
	Grid,
	GridColumn,
	Header,
	Pagination,
	Segment,
	Tab,
	Table,
	Label,
	Dropdown,
	Modal,
	Container
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import Dashboard from 'stores/ui/user/Dashboard';
import { withRouter } from 'react-router-dom';
import * as styles from './styles';
import { observable } from 'mobx';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import type { ScriptCounts } from 'types/common';
import ScriptNew from 'components/Script/ScriptNew';
import ScriptApproval from 'components/Script/ScriptApproval';
import ScriptPending from 'components/Script/ScriptPending';
import ScriptManual from 'components/Script/ScriptManual';
import ScriptUploaded from 'components/Script/ScriptUploaded';
import SortByField from 'components/SortByField';
import UiShared from 'stores/UiShared';
import Rx from 'stores/Rx';
import API from 'api';
import NotifyPrescriber from 'routes/User/NotifyPrescriber';
import ConsentSignature from 'stores/ui/manager/ConsentSignature';
import Consent from 'components/Consent';
import { action } from 'mobx/lib/mobx';

@withRouter
@inject(rootStore => ({
	dashboard: rootStore.ui.user.dashboard,
	consentSignature: rootStore.ui.manager.consentSignature,
	uiShared: rootStore.uiShared,
	auth: rootStore.auth
}))
@observer
export default class ManagerDashboard extends React.Component {
	props: {
		dashboard: Dashboard,
		uiShared: UiShared,
		auth?: Auth,
		consentSignature: ConsentSignature
	};

	@observable pageSize: number = 100;
	@observable scriptToDisplayId: number = null;
	@observable scriptToDisplayStatus: string = '';
	@observable scriptToDisplayIdManual: number = null;
	@observable scriptToDisplayIdUploaded: number = null;
	@observable scriptNewIsOpen: boolean = false;
	@observable notifyIsOpen: boolean = false;
	@observable scriptToApproveId: number = null;
	@observable prodaLoggedIn: boolean = false;
	@observable prodaRedirectUri: string = '';
	@observable prodaClientId: string = '';
	@observable prodaBaseUrl: string = '';
	@observable consentChecked: boolean = false;
	@observable prodaChecked: boolean = false;
	@observable consentIsOpen: boolean = false;

	msgStore: MsgStore = new MsgStore();

	async componentDidMount() {
		const { dashboard, uiShared } = this.props;
		this.consentChecked = false;
		const silent = window.location.hash.indexOf('?s=') !== -1;
		try {
			const self = this;
			if (this.prodaChecked === false && !silent) {
				uiShared.showSpinner('Loading');
			}
			const res = await API.get('/ProdaActivities/getTokenStatus');
			this.prodaLoggedIn = res.status === 'OK';
			this.prodaRedirectUri = res.prodaRedirectUri;
			this.prodaClientId = res.prodaClientId;
			this.prodaBaseUrl = res.prodaBaseUrl;
			const errorIndex = window.location.hash.indexOf('?error=');
			if (errorIndex > -1) {
				this.msgStore.setError(decodeURIComponent(window.location.hash.substring(errorIndex + 7)));
			}
			if (!this.prodaLoggedIn) {
				this.props.uiShared.redirectProda = true;
				setTimeout(function() {
					window.location.href = `${self.prodaBaseUrl}/authorize?response_type=code&client_id=${
						self.prodaClientId
					}&redirect_uri=${self.prodaRedirectUri}&scope=PBSAuthorities`;
				}, 1500);
			} else {
				setTimeout(function() {
					if (!self.consentIsOpen) {
						self.props.uiShared.hideModal();
					}
				}, 1500);
				dashboard.loadScriptCounts();
				dashboard.loadItems();
				this.prodaChecked = true;
			}
		} catch (err) {
			this.msgStore.setError(err);
		}
	}

	componentDidUpdate = prevProps => {
		const { consentChecked } = this;
		const { consentSignature } = this.props;
		if (this.prodaLoggedIn && !consentChecked && !consentSignature.isLoading) {
			this.consentChecked = true;
			if (!consentSignature.isSigned) {
				this.consentIsOpen = true;
			}
		}
	};

	getTabPanes = (scriptCount: ScriptCounts = {}) => {
		return [
			{
				menuItem: `All Scripts (${Object.values(scriptCount).reduce(
					(total, current) => total + current,
					0
				)})`,
				key: 'all'
			},
			{
				menuItem: `New (${scriptCount['new'] || 0})`,
				key: 'new'
			},
			{
				menuItem: `Pending (${scriptCount['pending'] || 0})`,
				key: 'pending'
			},
			{
				menuItem: `Uploaded (${scriptCount['uploaded'] || 0})`,
				key: 'uploaded'
			},
			{
				menuItem: `Approved (${scriptCount['approved'] || 0})`,
				key: 'approved'
			},
			{
				menuItem: `Cancelled (${scriptCount['cancelled'] || 0})`,
				key: 'cancelled'
			},
			{
				menuItem: `Rejected (${scriptCount['rejected'] || 0})`,
				key: 'rejected'
			},
			{
				menuItem: `Deferred (${scriptCount['deferred'] || 0})`,
				key: 'deferred'
			}
		];
	};

	@action
	onConsentClose = (shouldLogout = false) => {
		this.consentIsOpen = false;
		if (shouldLogout) {
			this.props.auth.logOut();
		}
	};

	render() {
		const { dashboard, uiShared } = this.props;
		const { items } = dashboard;
		const { onConsentClose } = this;
		return (
			<Segment loading={dashboard.isLoading || this.consentIsOpen}>
				<Header as="h1">Dashboard</Header>
				<MessageBox msgStore={this.msgStore} />

				<div className={styles.tabsWrapper}>
					<Tab
						menu={{ pointing: true, compact: true }}
						onTabChange={(event, data) => {
							let panes = this.getTabPanes();
							dashboard.setStatusFilter(panes[data.activeIndex].key);
						}}
						panes={this.getTabPanes(dashboard.scriptCountMy)}
					/>
				</div>
				<div className={styles.topBtnRow}>
					<div>
						<Button
							primary
							label="Add Rx Record"
							icon="plus"
							onClick={() => {
								this.scriptNewIsOpen = true;
							}}
						/>
						<Button
							primary
							onClick={() => {
								this.notifyIsOpen = true;
							}}
							style={{ marginLeft: '55px' }}
						>
							Notify Prescriber
						</Button>
					</div>
					<div>
						<Label size="large" basic className={styles.recordsLbl}>
							Records per page:
						</Label>
						<Dropdown
							selection
							placeholder="Records per page"
							value={this.pageSize}
							onChange={(e, data) => {
								this.pageSize = data.value;
								dashboard.setPageSize(data.value);
							}}
							compact
							options={[
								{ text: '10', value: 10 },
								{ text: '20', value: 20 },
								{ text: '50', value: 50 },
								{ text: '100', value: 100 }
							]}
						/>
					</div>
				</div>
				<Grid>
					<GridColumn>
						<Table celled>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell colSpan="13" textAlign="right">
										{dashboard.numberOfPages > 0 && (
											<Pagination
												activePage={dashboard.pageIndex + 1}
												totalPages={dashboard.numberOfPages}
												onPageChange={(e, { activePage }) => dashboard.setPageIndex(activePage - 1)}
											/>
										)}
									</Table.HeaderCell>
								</Table.Row>
								<Table.Row>
									<Table.HeaderCell>
										<SortByField
											label="Prescriber"
											field="searchPrescriber"
											filterType="like"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Practice"
											field="searchPractice"
											filterType="like"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Patient"
											label2="Name"
											field="searchPatientName"
											filterType="like"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Script"
											label2="Date"
											field="rxDate"
											store={dashboard}
											filterType="date"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Uploaded"
											label2="Date"
											field="uploadedtoHPOS"
											store={dashboard}
											enableFiltering
											filterType="date"
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Approval"
											label2="Date"
											field="finalisationDate"
											store={dashboard}
											filterType="date"
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Auth"
											label2="No"
											field="authorityNo"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Upload"
											label2="Reference"
											field="hposUploadReference"
											filterType="like"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Status</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Approval"
											label2="No"
											field="approvalNumber"
											filterType="like"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>
										<SortByField
											label="Last"
											label2="Updated by"
											field="modifiedBy"
											filterType="like"
											store={dashboard}
											enableFiltering
										/>
									</Table.HeaderCell>
									<Table.HeaderCell>Actions</Table.HeaderCell>
								</Table.Row>
							</Table.Header>

							<Table.Body>
								{items.map((el: Rx, idx) => (
									<Table.Row key={idx}>
										<Table.Cell>{el.searchPrescriber}</Table.Cell>
										<Table.Cell>{el.searchPractice}</Table.Cell>
										<Table.Cell>{el.searchPatientName}</Table.Cell>
										<Table.Cell>{el.rxDate?.toDate().format('DD/MM/YY')}</Table.Cell>
										<Table.Cell>{el.uploadedtoHPOS?.toDate().format('DD/MM/YY')}</Table.Cell>
										<Table.Cell>
											{el.status === 'approved'
												? el.finalisationDate?.toDate().format('DD/MM/YY')
												: ''}{' '}
										</Table.Cell>
										<Table.Cell>{el.authorityNo}</Table.Cell>
										<Table.Cell>{el.hposUploadReference}</Table.Cell>
										<Table.Cell style={this.formatStatus(el)}>
											{el.status?.toUpperCase()}
										</Table.Cell>
										<Table.Cell>{el.approvalNumber}</Table.Cell>
										<Table.Cell>{el.modifiedBy}</Table.Cell>
										<Table.Cell nowrap="nowrap">
											<Fragment>
												<Button
													icon="eye"
													size="small"
													label="Display"
													primary
													onClick={() => {
														if (el.manual) {
															if (el.status === 'new') {
																this.scriptToDisplayIdManual = el.id;
															} else if (el.status === 'uploaded') {
																this.scriptToDisplayIdUploaded = el.id;
															} else {
																this.scriptToDisplayId = el.id;
															}
														} else {
															this.scriptToDisplayId = el.id;
														}
														this.scriptToDisplayStatus = el.status;
													}}
												/>
												{el.fileImportStatus === 'imported' && (
													<Button
														primary
														disabled={!el.filePath}
														onClick={() => {
															window.open(el.filePath);
														}}
														label="Rx"
														icon="download"
														className={styles.dbtn}
													/>
												)}
											</Fragment>
										</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>

							<Table.Footer>
								<Table.Row>
									<Table.HeaderCell colSpan="13" textAlign="right">
										{dashboard.numberOfPages > 0 && (
											<Pagination
												activePage={dashboard.pageIndex + 1}
												totalPages={dashboard.numberOfPages}
												onPageChange={(e, { activePage }) => dashboard.setPageIndex(activePage - 1)}
											/>
										)}
									</Table.HeaderCell>
								</Table.Row>
							</Table.Footer>
						</Table>
					</GridColumn>
				</Grid>
				<ScriptNew
					isOpen={
						(!!this.scriptNewIsOpen || !!this.scriptToDisplayId) &&
						this.scriptToDisplayStatus !== 'pending'
					}
					scriptId={this.scriptToDisplayId}
					onRequestReload={async () => {
						dashboard.reload();
					}}
					onRequestClose={(manual, id) => {
						if (id) {
							if (manual) {
								this.scriptToDisplayIdManual = Number(id);
							} else {
								this.scriptToApproveId = Number(id);
							}
						}
						this.scriptToDisplayId = null;
						this.scriptNewIsOpen = false;
					}}
					onRequestModify={id => {
						this.scriptToDisplayIdUploaded = Number(id);
						this.scriptToDisplayId = null;
					}}
				/>
				<ScriptApproval
					scriptId={this.scriptToApproveId}
					isOpen={!!this.scriptToApproveId}
					onRequestReload={async () => {
						dashboard.reload();
					}}
					onRequestClose={() => {
						this.scriptToApproveId = null;
					}}
				/>
				<ScriptPending
					scriptId={this.scriptToDisplayId}
					isOpen={!!this.scriptToDisplayId && this.scriptToDisplayStatus === 'pending'}
					onRequestReload={async () => {
						dashboard.reload();
					}}
					onRequestClose={shouldSubmit => {
						const id = this.scriptToDisplayId;
						this.scriptToDisplayId = null;
						this.scriptToDisplayStatus = '';
						if (shouldSubmit) {
							this.quietSubmit = true;
							this.scriptToApproveId = id;
						}
					}}
					onRequestModify={() => {
						this.scriptToDisplayStatus = '';
					}}
					canSubmit={true}
				/>
				<ScriptManual
					scriptId={this.scriptToDisplayIdManual}
					isOpen={!!this.scriptToDisplayIdManual}
					onRequestReload={async () => {
						dashboard.reload();
					}}
					onRequestClose={id => {
						this.scriptToDisplayIdManual = null;
						this.scriptToDisplayId = Number(id);
					}}
				/>
				<ScriptUploaded
					scriptId={this.scriptToDisplayIdUploaded}
					isOpen={!!this.scriptToDisplayIdUploaded}
					onRequestReload={async () => {
						dashboard.reload();
					}}
					onRequestClose={id => {
						if (id) {
							this.scriptToDisplayId = Number(id);
						}
						this.scriptToDisplayIdUploaded = null;
					}}
				/>
				<NotifyPrescriber
					isOpen={this.notifyIsOpen}
					onRequestClose={() => {
						this.notifyIsOpen = false;
					}}
				/>
				<Consent
					isOpen={this.prodaLoggedIn && this.consentIsOpen}
					onRequestClose={logout => {
						this.props.uiShared.hideModal();
						onConsentClose(logout);
					}}
				/>
				<Fragment>
					<Modal
						open={this.props.uiShared?.redirectProda}
						className={styles.modalConfirmation}
						style={{ height: '145px' }}
						size="mini"
					>
						<Fragment>
							<Modal.Content style={{ height: '100%' }}>
								<Segment basic>
									<Container>
										<p>Your Proda session has expired.</p>
										<p>Redirecting to PRODA...</p>
									</Container>
								</Segment>
							</Modal.Content>
							<Modal.Actions>
								<Button positive onClick={() => {}}>
									OK
								</Button>
							</Modal.Actions>
						</Fragment>
					</Modal>
				</Fragment>
			</Segment>
		);
	}
	formatStatus(el) {
		const flag = el.status === 'rejected' && !el.actioned;
		return {
			color: flag ? 'red' : 'black',
			fontWeight: flag ? 'bold' : 'normal'
		};
	}
}



// WEBPACK FOOTER //
// ./src/routes/User/Dashboard.js